import { V1 } from './net'
import { StoreThunkDispatch } from 'store/state'

export function reorderPosts(ids: string[], moveTo?: 'top' | 'bottom') {
  return (dispatch: StoreThunkDispatch) => {
    if (moveTo === 'bottom') {
      return dispatch(V1.moveToBottom(ids.pop() as string))
    }
    if (moveTo === 'top') {
      return dispatch(V1.moveToTop(ids.shift() as string))
    }
    return dispatch(V1.reorderPosts(ids))
  }
}
